// extracted by mini-css-extract-plugin
module.exports = {"title":"PropertyList_title__2Kc5a","divider":"PropertyList_divider__3siJD","subtitle":"PropertyList_subtitle__9PITZ"};